import { IKeywordsAutoSuggestService } from 'shared/services/interface'
import config from 'config'
import type { AutoSuggestQuery, AutoSuggestResponse } from '~/app/features/Gallery/queries/interface'

import { AbstractService } from 'shared/services/AbstractService'
import getLogger from 'shared/logger'
import { stringifyArrayFormatRepeat } from '~/shared/url'

const DEFAULT_AUTOSUGGEST_QUERY = {} as AutoSuggestQuery

export class KeywordsAutoSuggestApi extends AbstractService implements IKeywordsAutoSuggestService {
  /**
   * Given a AutoSuggestQuery object, request new suggestions from the KeywordsAutoSuggest Service
   *
   * @param query
   * @throws ServiceError
   */
  public async getSuggestions(query: AutoSuggestQuery = DEFAULT_AUTOSUGGEST_QUERY): Promise<AutoSuggestResponse> {
    const { locale, galleryName, keyword, limit, noCache, searchBackend, ...rest } = query

    const url = `v2/Galleries/${encodeURIComponent(galleryName)}/Culture/${encodeURIComponent(locale)}`

    try {
      const { data } = await this.api.get<string[]>(url, {
        params: {
          keywordFragment: keyword,
          limit,
          requestor: noCache ? config.noCacheRequestor : config.appName,
          searchBackend,
          ...rest,
        },
        paramsSerializer: stringifyArrayFormatRepeat,
      })

      const resp = {
        suggestions: data,
        requestUrl: url,
      }

      return resp
    } catch {
      return {
        suggestions: [],
        requestUrl: url,
      }
    }
  }
}

export const KeywordsAutoSuggestService = new KeywordsAutoSuggestApi(config.services.designConductorService, getLogger)
